import webhooks from "./webhooks";
import webhookLogs from "./webhookLogs";
import webhookResponses from "./webhookResponses";

export default {
    namespaced: true,

    modules: {
        webhooks,
        webhookLogs,
        webhookResponses,
    },
};
